const DollarIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="32"
      viewBox="0 0 20 32"
      fill="none"
      stroke="#FB6514"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.168 1.33334V30.6667M16.8346 6.66668H6.83464C5.59696 6.66668 4.40997 7.15834 3.5348 8.03351C2.65963 8.90868 2.16797 10.0957 2.16797 11.3333C2.16797 12.571 2.65963 13.758 3.5348 14.6332C4.40997 15.5083 5.59696 16 6.83464 16H13.5013C14.739 16 15.926 16.4917 16.8011 17.3668C17.6763 18.242 18.168 19.429 18.168 20.6667C18.168 21.9044 17.6763 23.0913 16.8011 23.9665C15.926 24.8417 14.739 25.3333 13.5013 25.3333H2.16797"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DollarIcon
